import Vue from "vue";
import VueRouter from "vue-router";
import Upload from "@/components/Upload.vue";
import DeveloperChecklist from "@/components/DeveloperChecklist.vue";
import SuccessPage from "@/components/SuccessPage.vue";
import RentalGuideBook from "@/components/RentalGuideBook.vue"
import LeaseUpForm from "@/components/LeaseUpForm.vue";
import TenantIncome from "@/components/TenantIncome.vue";
import ChildInfo from "@/components/ChildInfo.vue";
import ConfirmationPage from "@/components/ConfirmationPage.vue";
import Login from "@/components/Login.vue";
import ProjectSummaryForm from "@/components/ProjectSummaryForm.vue";
import RFPProjectInformation from "@/components/RFPProjectInformation.vue";
import ProjectTeam from "@/components/ProjectTeam.vue";
import SiteInformation from "@/components/SiteInformation.vue";
import UnitDetails from "@/components/UnitDetails.vue";
import Development from "@/components/Development.vue";
import RFPConfirmationPage from "@/components/RFPConfirmationPage.vue";
import RFPSuccessPage from "@/components/RFPSuccessPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/ProjectSummaryForm",
    name: "ProjectSummaryForm",
    component: ProjectSummaryForm
  },
  {
    path: "/RFPSuccessPage",
    name: "RFPSuccessPage",
    component: RFPSuccessPage
  },
  {
    path: "/Development",
    name: "Development",
    component: Development
  },
  {
    path: "/RFPConfirmationPage",
    name: "RFPConfirmationPage",
    component: RFPConfirmationPage
  },
  {
    path: "/UnitDetails",
    name: "UnitDetails",
    component: UnitDetails
  },
  {
    path: "/SiteInformation/:siteId?",
    props: true,
    name: "SiteInformation",
    component: SiteInformation
  },
  {
    path: "/ProjectTeam",
    name: "ProjectTeam",
    component: ProjectTeam
  },
  {
    path: "/RFPProjectInformation",
    name: "RFPProjectInformation",
    component: RFPProjectInformation
  },
  {
    path: "/",
    name: "DeveloperChecklist",
    component: DeveloperChecklist
  },
  {
    path: "/LeaseUpForm/:recordId",
    props: true,
    name: "LeaseUpForm",
    component: LeaseUpForm
  },
  {
    path: "/RentalGuideBook",
    name: "RentalGuideBook",
    component: RentalGuideBook
  },
  {
    path: "/SuccessPage",
    name: "SuccessPage",
    component: SuccessPage
  },
  {
    path: "/Upload/:recordID?/:project?/:fileType?",
    props: true,
    name: "Upload",
    component: Upload
  },
  {
    path: "/TenantIncome/:tenantId",
    props: true,
    name: "TenantIncome",
    component: TenantIncome
  },
  {
    path: "/ChildInfo/:childId",
    props: true,
    name: "ChildInfo",
    component: ChildInfo
  },
  {
    path: "/ConfirmationPage",
    name: "ConfirmationPage",
    component: ConfirmationPage
  },
  {
    path: "/Login",
    name: "Login",
    component: Login
  },
  
  
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
